import { Component } from "react"
import classNames from "classnames"
import PropTypes from "prop-types"
import { TableRow, TableCell } from "@mui/material"

class CoverageReportRow extends Component {
  static propTypes = {
    hasPnl: PropTypes.bool.isRequired,
    hasEquity: PropTypes.bool.isRequired,
    date: PropTypes.object.isRequired,
    showDate: PropTypes.func.isRequired,
  }

  showDate = () => {
    const { date, showDate } = this.props

    if (date.unmappedEquities > 0) {
      showDate(date.date)
    }
  }

  render() {
    const { date, hasPnl, hasEquity } = this.props
    return <TableRow onClick={this.showDate} className={classNames("coverage-report-table-row", { unclickable: date.unmappedEquities === 0 })}>
      <TableCell>{date.formattedDate}</TableCell>
      {hasEquity && <TableCell align="right">{date.formattedEquity}</TableCell>}
      {hasPnl && <TableCell align="right">{date.formattedPnl}</TableCell>}
      <TableCell align="right">{date.percentModeled}</TableCell>
      <TableCell align="right">{date.percentUnmodeled}</TableCell>
      <TableCell align="right">{date.percentUnmappedEquities}</TableCell>
      <TableCell align="right">{date.unmappedEquities}</TableCell>
    </TableRow>
  }
}

export default CoverageReportRow
